import { QNA_MODIFY_EMAIL_MODAL } from '@repo/constants';
import { Button, Modal } from '@successmode-ktp/kui';
import { Input } from '@repo/components';
import { ChangeEvent, useState } from 'react';
import styled from 'styled-components';
import { validateEmail } from '@repo/utils';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  lang: 'KOR' | 'ENG';
  email: string;
  onModify: (email: string) => void;
};

export const ModifyEmailModal = ({
  isOpen,
  onClose,
  lang,
  email,
  onModify,
}: Props) => {
  const [newEmail, setNewEmail] = useState(email);
  const [error, setError] = useState<{ message: string } | null>(null);

  const handleChangeEmail = (e: ChangeEvent<HTMLInputElement>) => {
    setNewEmail(e.target.value);
    setError(null);
  };

  const handleModify = () => {
    if (validateEmail(newEmail)) {
      onModify(newEmail);
      setError(null);
      onClose();
    } else {
      setError({ message: QNA_MODIFY_EMAIL_MODAL[lang].error });
    }
  };
  return (
    <Modal
      isOpen={isOpen}
      hasBackdrop
      wrapperStyle={{ minWidth: '340px' }}
      order={10}
    >
      <Inner>
        <Header>{QNA_MODIFY_EMAIL_MODAL[lang].title}</Header>
        <Input
          value={newEmail}
          onChange={handleChangeEmail}
          isRequired
          label={QNA_MODIFY_EMAIL_MODAL[lang].label}
          placeholder={QNA_MODIFY_EMAIL_MODAL[lang].placeholder}
          error={error}
        />
        <Description>{QNA_MODIFY_EMAIL_MODAL[lang].description}</Description>
        <ButtonWrapper>
          <Button type='button' theme='mono' variant='solid' onClick={onClose}>
            {QNA_MODIFY_EMAIL_MODAL[lang].btnCancel}
          </Button>
          <Button
            type='button'
            onClick={handleModify}
            disabled={newEmail.length === 0}
          >
            {QNA_MODIFY_EMAIL_MODAL[lang].btnSend}
          </Button>
        </ButtonWrapper>
      </Inner>
    </Modal>
  );
};

const Inner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const Header = styled.h3`
  color: var(--KTP-Grayscale-100, var(--KTP-Color-Mono-100, #030303));
  text-align: center;
  font-family: Pretendard;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 27px */
  letter-spacing: -0.45px;
  width: 100%;
`;

const Description = styled.p`
  color: var(--KTP-Grayscale-50, var(--KTP-Color-Mono-50, #80848a));
  text-align: center;
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 10px;
`;
